import {
  BLOQUE_DEVIS, OPTION, FACTURE, BLOQUE_COMMANDE, LIBRE, EN_ATTENTE,
  VERT, BLUE, BLANC, JAUNE, ORANGE, ROUGE,
} from '@/configuration/planning/planningReseauTempoColorConf';
import getNbFacesByEtatObtenu from '@/services/optionBlocage/getNbFacesByEtatObtenu';
import {
  ETAT_PAYE, TYPE_DEVIS,
  ETAT_ENREGISTRE, ETAT_SANSSUITE,
} from '@/configuration/devisConf';

function getFirstBlockInformation(nbFaceBloqueDevis, nbFaceBloqueCommande,
  nbFaceFacture, stockSemaine) {
  const nbFaces = nbFaceFacture + nbFaceBloqueDevis + nbFaceBloqueCommande;
  let percent;
  if (stockSemaine === 0) percent = (stockSemaine - nbFaces) < 0 ? 100 : 0;
  else percent = Math.round((nbFaces * 100) / stockSemaine);

  // Si il n'y a pas de controle de disponibilité on peut passer 100%
  // Dans ce cas la, on prend le niveau de blocage de plus haut.
  if (percent > 100) {
    let color = BLOQUE_DEVIS;
    if (nbFaceBloqueCommande > 0) color = BLOQUE_COMMANDE;
    if (nbFaceFacture > 0) color = FACTURE;
    return { percent: 100, color: color };
  }

  let color = FACTURE;
  if (nbFaceBloqueDevis > 0) color = BLOQUE_DEVIS;
  else if (nbFaceBloqueCommande > 0) color = BLOQUE_COMMANDE;

  return { percent, color };
}

function getBackgroundImage(
  firstBlock,
  nbFaceBloqueOption,
  nbFaceEnAttenteRelanceOption,
  stockSemaine,
) {
  let percent = 0;
  if (stockSemaine !== 0) {
    percent = ((nbFaceEnAttenteRelanceOption > 0
      ? nbFaceEnAttenteRelanceOption : nbFaceBloqueOption)
      * 100 / stockSemaine).toFixed(0);
  }
  let color = LIBRE;
  if (nbFaceEnAttenteRelanceOption > 0) color = EN_ATTENTE;
  else if (nbFaceBloqueOption > 0) color = OPTION;
  if (firstBlock.percent === 0) {
    return `background-image: linear-gradient(90deg, ${color} 0%, ${color} ${percent}%, ${LIBRE} ${percent}%, ${LIBRE} 100%)`;
  }
  return `background-image: linear-gradient(90deg, ${firstBlock.color} 0%, ${firstBlock.color} ${firstBlock.percent}%, ${color} ${firstBlock.percent}%, ${color} 100%)`;
}

export default function calculateStyleCelluleEtatObtenu(dispo) {
  if (!dispo.allAffectationOfProduct) return '';
  const nbFaces = getNbFacesByEtatObtenu(dispo.allAffectationOfProduct);
  const firstBlock = getFirstBlockInformation(nbFaces.nbFaceDevis, nbFaces.nbFaceCommande,
    nbFaces.nbFaceFacture, dispo.stock);
  return getBackgroundImage(firstBlock, nbFaces.nbFaceBloqueOption,
    nbFaces.nbFaceEnAttente || nbFaces.nbFaceRelanceOption, dispo.stock);
}

export function calculateStyleCelluleEcheancierLigne(echeancierLigne, ligneCommande) {
  if (!echeancierLigne) return '';
  let color = VERT;
  if (echeancierLigne.facture) {
    color = BLUE;
    if (echeancierLigne.facture.etat === ETAT_PAYE) color = BLANC;
  }
  if (ligneCommande.devisCommande.type === TYPE_DEVIS) {
    if (ligneCommande.devisCommande.etat === ETAT_ENREGISTRE) {
      color = JAUNE;
      if (ligneCommande.devisCommande.transmissionAuClient) color = ORANGE;
    }
    if (ligneCommande.devisCommande.etat === ETAT_SANSSUITE) color = ROUGE;
  }
  return `background-color:  ${color}!important`;
}
